<template>
  <div>
    <v-text-field
      :label="label"
      hint="List of coma-separated NORAD IDs, e.g : 51326, 41536, 52316"
      v-model="idsAsText"
      :error-messages="idsErrorMessage"
      :disabled="disabled"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: 'NoradTextField',

  data() {
    return { invalidIdsText: null }
  },

  computed: {
    idsAsText: {
      get() {
        if (this.value != null) {
          return this.value.join(', ') + ' '
        } else {
          return this.invalidIdsText
        }
      },
      set(newValue) {
        const parsedIds = this.parseIds(newValue)
        if (parsedIds == null) {
          this.invalidIdsText = newValue
          this.$emit('input', null)
        } else {
          this.$emit('input', parsedIds)
          this.invalidIdsText = null
        }
      }
    },
    idsErrorMessage() {
      return this.invalidIdsText == null
        ? []
        : ['The input NORAD IDs are invalid.']
    }
  },

  props: {
    value: {
      type: Array
    },
    label: {
      type: String,
      default: 'NORAD IDs of this group members'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    parseIds(idsText) {
      const regex_ids = /\s*(?<id>[0-9]{5})\s*,?\s*/g
      const ids = []
      const matches = [...idsText.matchAll(regex_ids)]
      let newText = ''
      matches.forEach((id) => {
        newText += id[0]
        ids.includes(id.groups.id) ? '' : ids.push(id.groups.id)
      })
      if (newText.length === idsText.length) {
        return ids
      } else {
        return null
      }
    }
  }
}
</script>
